const rankingItems = [
  { rank: '01', title: '顶流男星深夜密会神秘女子，酒店监控全程曝光', summary: '据知情人士透露，该男子为当红一线流量小生，视频中清晰可见两人牵手进入电梯。', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: '02', title: '千万粉丝网红直播翻车，假货实锤引发退货潮', summary: '带货一姐直播间号称原装进口产品，被网友扒出生产地实为某乡镇小作坊。', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: '03', title: '知名导演片场怒骂演员视频流出，剧组气氛紧张', summary: '片场工作人员偷拍三段视频曝光，多名群演证实导演长期对演员言语暴力。', tag: '热', tagColor: 'bg-accent-500' },
  { rank: '04', title: '女团成员私下吐槽公司压榨，录音门持续发酵', summary: '长达12分钟的录音中，该成员详述经纪公司克扣分成、强制整容等内幕。', tag: '热', tagColor: 'bg-accent-500' },
  { rank: '05', title: '综艺节目黑幕被参赛选手实名举报', summary: '选秀出身歌手发长文控诉节目组操纵投票、内定冠军，附多张聊天截图。', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: '06', title: '某影视公司老板涉嫌洗钱被带走调查', summary: '知情人称该公司多部高票房电影存在虚报成本、阴阳合同等违规操作。', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: '07', title: '热门综艺常驻嘉宾突然被替换，背后真相揭晓', summary: '原来是该嘉宾拒绝配合节目组安排的剧本炒作，得罪了制作方高层。', tag: '新', tagColor: 'bg-secondary-500' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950">
            🔥 实时热度榜单
          </h2>
          <span className="hidden md:block text-sm text-foreground-500">
            按讨论量与爆料深度排序
          </span>
        </div>

        <div className="flex flex-col">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-start gap-4 md:gap-6 py-5 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <span className="text-4xl md:text-5xl font-black text-primary-500/80 leading-none min-w-[50px] md:min-w-[64px] text-right">
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-start gap-3">
                  <h3 className="text-base md:text-lg font-bold text-foreground-900 leading-snug flex-1 cursor-pointer hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold text-background-50 whitespace-nowrap ${item.tagColor}`}
                  >
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm text-foreground-500 mt-1.5 leading-relaxed">
                  {item.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}